export const apkChannel = "mybaidu";
// export const apkChannel = "Dev";
export const apkVersionName = "1.1.0";
export const phoneModel = "web";
export const apkVersionCode = "2";
export const apkId = 4;
export const phoneOsVersion = 10;
export const phoneOs = 2;